import { render } from "./index.vue?vue&type=template&id=47fe68e9"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/users-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47fe68e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47fe68e9', __exports__)) {
    api.reload('47fe68e9', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=47fe68e9", () => {
    api.rerender('47fe68e9', render)
  })

}


export default __exports__